import React from "react";
import { AddressBtnStyled } from "./addressBtn.styles";

const AddressBtn = ({ color, content, title, ...others }) => {
  return (
    <AddressBtnStyled color={color} {...others}>
      <div className="font-weight-bold ml-3">{title}</div>
      <div>{content}</div>
    </AddressBtnStyled>
  );
};

export default AddressBtn;
